const baseClasses =
  "rounded-full font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500";

const activeClasses = "bg-blue-600 text-white";
const inactiveClasses = "text-slate-700 hover:text-slate-900";

export function segmentedControlButtonClass({
  active,
  className = "",
  activeClassName = activeClasses,
  inactiveClassName = inactiveClasses,
}: {
  active: boolean;
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
}): string {
  const state = active ? activeClassName : inactiveClassName;

  return `${baseClasses} ${state} ${className}`.replace(/\s+/g, " ").trim();
}

